import { render, staticRenderFns } from "./CompanyPicker.vue?vue&type=template&id=2c4715d8&scoped=true&lang=pug&"
import script from "./CompanyPicker.vue?vue&type=script&lang=js&"
export * from "./CompanyPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4715d8",
  null
  
)

export default component.exports